import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
import { APPRoutes } from 'src/app/app.routes';

export const NonAuthenticatedGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return router.createUrlTree([APPRoutes.GROUPS]);
  }

  return true;
};
